import * as GSAP from 'gsap';
import AbstractElement from "../pages/AbstractElement";


class MosaicEffect extends AbstractElement {

    private rects: JQuery[];
    private timer: any;
    private pauseTimer: any;
    private startTimer: any;
    private t: any;
    private active: boolean;

    constructor(template: JQuery) {
        super(template);
    }


    update(scrollTop: number = 0, fixRange: number = 0): void {
        const screenCenter = {
            x: window.innerWidth * 0.5,
            y: window.innerHeight * 0.5
        };
        const distance = (this.template.offset().top - scrollTop);
        if (distance <= (screenCenter.y + fixRange)) {
            if (this.isTransition) return;
            this.start();
        }
       /* if (distance >= window.innerHeight) {
            this.isTransition = false;
            this.active = false;
        }*/
    }

    init(): void {
        this.rects = [];
        this.initRect();
    }

    private initRect(): void {
        const $mask = this.template.find('.ratio__mask');
        $mask.html('');
        const rowHTML = `<div class="mosaic__rect-row"></div>`;
        const rectHTML = `<div class="mosaic__rect"></div>`;
        let rectIndex = 0;

        const rectWidth = Math.floor(this.template.width() / 10);
        const rectTotal = this.template.width() / rectWidth;
        for (let i = 0; i < 4; i++) {
            $mask.append(rowHTML);
            const $row = $mask.find('.mosaic__rect-row:eq(' + i + ')');
            for (let j = 0; j < rectTotal; j++) {
                $row.append(rectHTML);
                const $rect = $mask.find('.mosaic__rect:eq(' + rectIndex + ')');
                this.rects.push($rect);
                rectIndex += 1;
            }
        }
    }

    private clearTimer(): void {
        window.clearInterval(this.timer);
        this.timer = null;

        window.clearTimeout(this.pauseTimer);
        this.pauseTimer = null;

        window.clearTimeout(this.startTimer);
        this.startTimer = null;
    }

    private pause(): void {
        this.pauseTimer = window.setTimeout(() => {
            this.clearTimer();
            // this.start();
        }, 1000);
    }

    private start(): void {
        /* this.startTimer = window.setTimeout(() => {
             this.startEffect();
         }, 3000);*/

        this.t = {x: 100};
        this.active = false;
        GSAP.TweenMax.to(this.t, 1, {
            delay: 0.2,
            x: 500,
            ease: GSAP.Power0.easeOut,
            onUpdate: () => {
                this.startEffect();
            }
        });
    }

    private static aTotal: number;
    private startEffect(): void {
        if (this.active) return;
        this.isTransition = true;
        this.active = true;
        this.startTimer = window.setTimeout(() => {
            this.active = false;
            MosaicEffect.aTotal = 0;
            this.rects.map((element: JQuery) => {
                const a = Math.random() * 0.5;
                GSAP.TweenMax.killTweensOf(element);
                GSAP.TweenMax.to(element, 0.3, {
                    css:{
                        'background-color': MosaicEffect.getRandomGrayColor()
                    },
                    ease:GSAP.Back.easeOut
                });
            });
            this.clearTimer();
        }, this.t.x);
    }

    static getRandomGrayColor(): string {
        const grayValue = Math.round(Math.random() * 100);
        const active = Math.floor(Math.random() * 2);
        let a = Math.random() * 0.6;
        if (MosaicEffect.aTotal <= 10) {
            if (active === 0) {
                a = 0;
            }
        }
        // const a = (active === 0) ? 0 : Math.random() * 0.5;
        return 'rgba(' + grayValue + ',' + grayValue + ',' + grayValue + ',' + a + ')';
    }
}

export default MosaicEffect;